import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { Provider } from "react-redux";
import {
  ErrorBoundary,
  ErrorFallback,
} from "./components/ErrorBoundary/index.ts";
import { store } from "./store/store";
import AppMsalProvider from "./shared/helper/MsalProvider.tsx";
import { initializeMsal } from "./shared/services/msal/msalInstance";
import { registerAuthEvents } from "./shared/services/auth/authEvents.ts";
import { NavigationStackProvider } from "./shared/context/NavigationStackContext.tsx";
import { CHUNK_RELOAD_KEY } from "./shared/constants/index.ts";
import { isCanceledError } from "./shared/utils/cancellation.util.ts";

const root = createRoot(document.getElementById("root")!);

window.addEventListener("unhandledrejection", (event) => {
  if (isCanceledError(event.reason)) {
    event.preventDefault();
    return;
  }

  const message = event.reason?.message || "";

  const isChunkError =
    message.includes("Failed to fetch dynamically imported module") ||
    message.includes("error loading dynamically imported module");

  if (isChunkError) {
    const hasReloaded = sessionStorage.getItem(CHUNK_RELOAD_KEY);

    if (!hasReloaded) {
      sessionStorage.setItem(CHUNK_RELOAD_KEY, "true");
      window.location.reload();
    }
  }
});

initializeMsal().then(() => {
  // Register MSAL event listeners ONCE
  registerAuthEvents();

  root.render(
    <StrictMode>
      <AppMsalProvider>
        <Provider store={store}>
          <NavigationStackProvider>
            <ErrorBoundary fallback={ErrorFallback}>
              <App />
            </ErrorBoundary>
          </NavigationStackProvider>
        </Provider>
      </AppMsalProvider>
    </StrictMode>,
  );
});
